import React, { Fragment, useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom';
import Pagination from '@mui/material/Pagination'
import * as constants from '../../../utils/Constants'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const CartList = () => {

    const [page, setPage] = useState(1);
    const [pageDetails, setPageDetails] = useState({})
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [sortBy, setSortBy] = useState('')
    const [items, setItems] = useState([]);
    const history = useHistory();
    let jobData = []
    let loggedInUser = JSON.parse(localStorage.getItem('user'))
    const [loginData, setLoginData] = useState({})
    const [data, setData] = useState(
        document.querySelectorAll('#application tbody tr')
    )

    useEffect(() => {
        getListJobs()
    }, [])
    let state = useLocation().state;
    state = {
        agentId: ''
    }
    function getListJobs() {
        fetch(`${constants.AgentWishListUrl}/${loggedInUser?.userId}`,
            {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                }
            })

            .then(res => res.json())
            .then(
                (result) => {
                    setIsLoaded(true);
                    setItems(result?.data);
                }
            )
    }
    const handlePageChange = (value) => {
        setPage(value);
    }
    if (items) {
        jobData = [...items];
    }
    const handleRowClick = (selectedRow) => {
        history.push({
            pathname: '/view-job',
            state: selectedRow
        })
    }
    const handleRelease = (job) => {
        var url = `${constants.AgentReleaseJobUrl}/${loggedInUser.userId}`;
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            },
            body: JSON.stringify({ "jobPostId": job.jobPostId })
        })
            .then(res => res.json())

        window.location.reload()
    }

    return (
        <Fragment>
            <div className='d-flex flex-wrap mb-4 align-items-center search-filter'>
                <div className='mr-auto mb-2 pr-2'>
                    <h6 className='text-black fs-16 font-w600 mb-1'>
                        Showing {pageDetails?.totalElements} Added Work Lists Results
                    </h6>
                    <span className='fs-14'>Based your preferences</span>
                </div>
            </div>
            <div className='row'>
                <div className='col-xl-12'>
                    <div className='table-responsive'>
                        <div id='application' className='dataTables_wrapper no-footer'>
                            <table
                                className='table display mb-4 dataTablesCard table-responsive-xl card-table dataTable no-footer'
                                id='example5'
                            >
                                <thead>
                                    <tr role='row'>
                                        <th className='sorting'>Job ID</th>
                                        <th className='sorting'>Job Title</th>
                                        {/* {loggedInUser.roles == 'Admin' &&
                                        <th className='sorting'>Company Name</th>
    } */}
                                        <th className='sorting'>Job Location</th>
                                        <th className='sorting'>View Candidates</th>
                                        <th className='sorting'>Job Added Date</th>
                                        <th className='sorting'>Release</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {jobData?.map((job) => (
                                        <tr role='row' style={{ cursor: 'pointer' }} className='odd' >
                                            <td onClick={() => handleRowClick(job)}>{job.jobPostId}</td>
                                            <td onClick={() => handleRowClick(job)}>{job.jobTitle}</td>
                                            {/* {loggedInUser.roles == 'Admin' &&
                                            <td onClick={() => handleRowClick(job)}>{job.jobCompanyName}</td>} */}
                                    
                                            <td onClick={() => handleRowClick(job)}>{job.city}</td>
                                            <td>
                                                <div>
                                                    <Link className='btn btn-primary btn-sm' style={{ backgroundColor: '#00ADEE', border: 'none' }}
                                                        to={{
                                                            pathname: '/applied-candidates',
                                                            state: job
                                                        }}>
                                                        <i className='fa fa-eye mr-2' />
                                                        Profile
                                                    </Link>
                                                </div>
                                            </td>
                                            <td onClick={() => handleRowClick(job)}>{new Date(job.jobAddedDate).toLocaleDateString()} {new Date(job.jobAddedDate).toLocaleTimeString()}</td>
                                            <td>
                                                <div>
                                                    <button style={{ border: 'none', backgroundColor: '#00ADEE' }}
                                                        type="button"
                                                        className="btn btn-primary btn-sm"
                                                        id="iop"
                                                        onClick={() => { handleRelease(job) }}
                                                    >
                                                        <i className='fa fa-trash' />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                    )}
                                </tbody>
                            </table>

                            <div className='d-sm-flex text-center justify-content-between align-items-center'>
                                <div className='dataTables_info' id='example5_info'>
                                    Page: {page}
                                </div>
                                <div>
                                    <Pagination count={pageDetails?.totalPages} page={page} onChange={handlePageChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment >
    )
}
export default CartList